module.exports = __webpack_public_path__ + "img/Mouth.b45fe3e.png";